import { Button, Input, message, Popover, Tooltip } from 'antd'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import API from '../../../../../utils/api'
import { useToken } from '../../../../hooks'

const BankInput = ({
	data,
	type,
	mutate = () => {},
	defaultmodify = false,
}: any) => {
	const { data: token } = useToken()
	const [memo, setMemo] = React.useState(data?.bankaccount)

	const [modify, setModify] = React.useState(defaultmodify)

	const saveMemo = () => {
		API.post('/admin/user/cash/bank', token + '', {
			type,
			id: data?.id,
			memo,
		})
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
				setModify(false)
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
	}

	return (
		<>
			{modify ? (
				<View style={{ width: 450, flexDirection: 'row' }}>
					<Input
						defaultValue={data?.bankaccount}
						value={memo}
						onChange={e => {
							setMemo(e.target.value)
						}}
						size="small"
					/>
					<Button
						size="small"
						type="primary"
						style={{ marginLeft: 5 }}
						onClick={saveMemo}>
						수정
					</Button>
					<Button
						size="small"
						style={{ marginLeft: 5 }}
						onClick={() => setModify(false)}>
						취소
					</Button>
				</View>
			) : (
				<Tooltip title={data?.bankaccount}>
					<Text
						onClick={() => setModify(true)}
						style={{
							cursor: 'pointer',
							whiteSpace: 'nowrap',
							width: 230,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							justifyContent: 'flex-start',
						}}>
						{data?.bankaccount}
					</Text>
				</Tooltip>
			)}
		</>
	)
}

export default React.memo(BankInput)
